import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { galleryActions, pageActions } from 'app/actions';
import PageView from 'app/views/pageView';
import { sendBrowserError } from '@unisporkal/instrumentation';
import { QUERY_KEYS } from 'src/constants';

const useSearchMutation = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  const mutation = useMutation<
    Record<string, unknown>,
    unknown,
    { searchPath: string; pushState: boolean },
    unknown
  >({
    mutationFn: async ({ searchPath, pushState }) => {
      const contributor = queryClient.getQueryData(QUERY_KEYS.contributor);

      if (typeof contributor === 'undefined') {
        queryClient.setQueryData(QUERY_KEYS.contributor, {});
      }

      dispatch(pageActions.pageStatusChanged(PageView.LOADING));
      return dispatch(galleryActions.search(searchPath, pushState) as any);
    },
    onSuccess: (response) => {
      // Deliberately does NOT invalidate agreements. This used to invalidate
      // ['search'], which is what made the agreements payload refetch on every
      // single search — the round trip this cutover removes. What a user holds
      // does not change because they searched for something else; only a
      // download changes it, and those sites invalidate the key themselves.
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.contributor });
      dispatch(pageActions.pageStatusChanged(PageView.LOADED));
      return response;
    },
    onError: (error: Error | unknown) => {
      sendBrowserError(
        error instanceof Error ? error : new Error(String(error))
      );
      dispatch(pageActions.pageStatusChanged(PageView.LOADED));
    },
  });
  return mutation;
};

export default useSearchMutation;
